export default __webpack_public_path__ + "static/media/BCT.b08b3cc3.png";